'use strict';

import Swiper from 'swiper';
import {Autoplay, Scrollbar, Pagination, Mousewheel} from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export function initSwiper() {

  new Swiper('.referenceSwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    autoHeight: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    modules: [Autoplay, Pagination],

  });


  new Swiper('.bandsSwiper', {
    slidesPerView: 1.5,
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: true,
    },
    speed: 10000,
    effect: 'slide',
    autoplay: {
      delay: false,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.5
      },
      1024: {
        slidesPerView: 4.5
      }
    },

    modules: [Autoplay, Scrollbar, Mousewheel],

  });
}

